import API from "serviceshift-ui/api-client";

import { AccountType, QuickbooksCompany } from "@/Marketplace/Quickbooks/types";

export default {
  async getOAuthURLForQuickbooks({ state }) {
    const response = await API.makeRequest<{ url: string }>(
      state.tenant.links?.qbo_oauth,
      {
        method: "GET"
      }
    );
    return response.data.url;
  },
  async getQuickbooksCompanies() {
    try {
      const response = await API.makeRequest<{
        data: QuickbooksCompany[];
      }>(`/v2/integration/qbo`);
      return response.data.data.map((item) => new QuickbooksCompany(item));
    } catch (e) {
      return [];
    }
  },
  async unlinkQuickbooksCompany(_, companyId: number | string) {
    return API.makeRequest(`/v2/integration/qbo/${companyId}`, {
      method: "DELETE",
      data: {
        id: companyId
      }
    });
  },
  async unlinkQuickbooksMapping(_, mappingId: number | string) {
    return API.makeRequest(`/v2/integration/qbo/mappings/${mappingId}`, {
      method: "DELETE",
      data: {
        id: mappingId
      }
    });
  },
  async refreshQuickbooksCompany(_, companyId: number | string) {
    return API.makeRequest(`/v2/integration/qbo/${companyId}/refresh`, {
      method: "POST",
      data: {
        id: companyId
      }
    });
  },
  async getQuickbooksAccountTypes() {
    try {
      const response = await API.makeRequest<{
        data: AccountType[];
      }>(`/v2/integration/qbo/account_types`);
      return response.data.data.map((item) => new AccountType(item));
    } catch (e) {
      return [];
    }
  },
  async saveAccount(
    _,
    params: {
      company_id: number | string;
      field: string;
      account_name: string;
    }
  ) {
    return API.makeRequest(`/v2/integration/qbo/${params.company_id}/account`, {
      method: "POST",
      data: {
        field: params.field,
        account_name: params.account_name
      }
    });
  }
};
